"use client";

import { useEffect } from "react";
import { hubspotTracker } from "./hubspotTracker";

/**
 * Declarative face of `hubspotTracker.identifyOnce` — stitch the authenticated
 * user's HubSpot session whenever their email changes. Lives here once instead
 * of being copy-pasted as a `useEffect` into every authenticated layout.
 */
export function useHubSpotIdentify(email?: string | null): void {
  useEffect(() => {
    hubspotTracker.identifyOnce(email);
  }, [email]);
}
